<template>
    <div class="box p-15">
        <div class="title is-5 campaign-title">
            {{ deal.title }}
        </div>

        <div class="mb-10" v-html="$sanitize(deal.objective)"></div>

        <button class="button" @click="$root.showDeal(deal.id)">View Partnership</button>
    </div>
</template>

<script>
    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'DealListRow',

        /**
         * The component properties
         */
        props: {
            /**
             * The deal
             */
            deal: {
                type: Object,
                required: true
            }
        },

        /**
         * The computed properties
         *
         * @type {Object}
         */
        computed: {}
    };
</script>
